<template>
  <div class="editor">
    <div ref='editor'></div>
  </div>
</template>

<script>
// import Vue from 'vue'
import E from 'wangeditor'
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getUploadOSSOption } from '../../api/newOss';

export default {
  name: 'editor',
  data() {
    return {
      editor: null,
      info_: null,

      accessKeyId: '',
      accessKeySecre: '',
      securityToken: '',
      endPoint: '',
      directory: '',
      bucket: '',
      bucketEndPoint: '',
      isChange:false,    //定义判读是否改变的变量
    }
  },
  model: {
    prop: 'desc',
    event: 'change'
  },
  watch: {
    isClear(val) {
      // console.log(val)
      if (val) {
        this.editor.txt.clear()
        // this.info_=null
      }
    },
    // desc(value) {
    //   // console.log("desc",value)
    //   if (value !== this.editor.txt.html()) {
    //     this.editor.txt.html(this.desc)
    //   }
    // },
    desc(newVal, oldVal) {
      if(!this.isChange) {
        this.editor.txt.html(newVal)
      }
      this.isChange = false;
    }
  },
  props: {
    desc: {
      type: String,
      default: ''
    },
    // 业务中我们经常会有添加操作和编辑操作，添加操作时，我们需清除上一操作留下的缓存
    isClear: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    init() {
      let obj = {
        sessionName: 'PC',
        type: 31 // 上传路径类型
      }
      getUploadOSSOption(obj).then(data => {
        if (data.resultCode == 1) {
          this.accessKeyId = data.resultObj.accessKeyId; // 临时id
          this.accessKeySecret = data.resultObj.accessKeySecret; // 临时Secret
          this.securityToken = data.resultObj.securityToken; // 临时token
          this.endPoint = data.resultObj.endPoint; // oss地址
          this.directory = data.resultObj.directory; // 上传路径
          this.bucket = data.resultObj.bucket; // bucket名称
          this.bucketEndPoint = data.resultObj.bucketEndPoint; // oss地址(含bucket)
        }
      })
    },
    initE() {
      this.editor = new E(this.$refs.editor);
      this.editor.customConfig.onchangeTimeout = 1000 // 单位 ms
      this.editor.customConfig.uploadFileName = 'file'
      this.editor.customConfig.uploadImgServer = localStorage.BaseUrlNew + '/video/image/upload' // 你的服务器地址
      this.editor.customConfig.uploadImgMaxSize = 100 * 1024 * 1024 // 100M
      this.editor.customConfig.showLinkImg = true; //隐藏网络图片上传
      this.editor.customConfig.customUploadImg = (files, insert) => {
        // files 是 input 中选中的文件列表
        // insert 是获取图片 url 后，插入到编辑器的方法
        // 引入oss this._ossConfValue是通过接口获取到的ali-oss配置信息
        const OSS = require("ali-oss");
        let client = new OSS({
          region: "oss-cn-beijing",  // 阿里云地址
          accessKeyId: this.accessKeyId, // 秘钥id
          accessKeySecret: this.accessKeySecret, // 秘钥密码 
          stsToken: this.securityToken,
          bucket: this.bucket, // bunket是将文件存放到阿里云哪个文件夹的地址+ '/'
        });

        files.forEach(item => {
          // oss上传文件 第一个参数是阿里云文件夹地址+文件名称 第二个是编辑器返回的图片文件流
          client.put(this.directory + guid()+item.name.substr(item.name.lastIndexOf(".")), item).then(result => {
            let _res = result.res;
            if (_res.status === 200 && _res.statusCode === 200) {
              // 上传代码返回结果之后，将图片插入到编辑器中
              insert(_res.requestUrls[0].split("?")[0]);
            }
          });

        });
      };
      
      this.editor.customConfig.uploadImgHooks = {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
        before: function (xhr, editor, files) {},
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        success: function (xhr, editor, result) {},
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        fail: function (xhr, editor, result) {},
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        error: function (xhr, editor) {},
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        timeout: function (xhr, editor) {},

        // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          console.log(result.url)
          var url = result.url
          insertImg(url)

          // result 必须是一个 JSON 格式字符串！！！否则报错
        }
      }
      this.editor.customConfig.onchange = (html) => {
        this.isChange = true;
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
      }
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        // 'video', // 插入视频
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]
      this.editor.create()
      this.editor.txt.html(this.desc)
      // this.editor.customConfig.customUploadInit = this.uploadOSS(this.editor).init()
      // 用于生成uuid
      function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }
      function guid() {
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
      }
    }
  },
  mounted() {
    this.init()
    this.initE()
  }
}
</script>

<style scoped>
.editor {
  /* border: 1px solid #ccc;
  min-height: 350px; */
  position: relative;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// MyWangEditor.vue?5faba5f3